import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "exam-time"
};
const _hoisted_2 = {
  key: 1,
  class: "paper-context oral-paper-context"
};
const _hoisted_3 = {
  class: "question-text"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "question-status"
};
const _hoisted_7 = {
  class: "icon play-icon loading-ani",
  style: {
    "width": "50px",
    "height": "50px"
  }
};
const _hoisted_8 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_step = _resolveComponent("el-step");
  const _component_el_steps = _resolveComponent("el-steps");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_SelfEvaluation = _resolveComponent("SelfEvaluation");
  const _component_Recorder = _resolveComponent("Recorder");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_steps, {
    active: $setup.step == 1 ? $setup.step + $setup.itemNo : $setup.step + $setup.itemNo + 1,
    simple: ""
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_el_step, {
      title: "考前自评",
      icon: $setup.List
    }, null, 8, ["icon"]), [[_vShow, $props.examInfo.examType != 3]]), _createVNode(_component_el_step, {
      title: "任务一",
      icon: $setup.EditPen
    }, null, 8, ["icon"]), _createVNode(_component_el_step, {
      title: '任务二(' + ($setup.step == 1 ? $setup.taskNo - 0 + 1 : 7) + '/7)',
      icon: $setup.EditPen
    }, null, 8, ["title", "icon"]), _createVNode(_component_el_step, {
      title: "任务三",
      icon: $setup.EditPen
    }, null, 8, ["icon"]), _createVNode(_component_el_step, {
      title: "任务四",
      icon: $setup.EditPen
    }, null, 8, ["icon"]), _createVNode(_component_el_step, {
      title: "任务五",
      icon: $setup.EditPen
    }, null, 8, ["icon"]), _withDirectives(_createVNode(_component_el_step, {
      title: "考后自评",
      icon: $setup.List
    }, null, 8, ["icon"]), [[_vShow, $props.examInfo.examType != 3]])]),
    _: 1
  }, 8, ["active"]), $setup.paperInfo.items && ($setup.step == 1 || $setup.step == 2) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "margin-right": "5px",
      "font-size": "20px"
    },
    icon: $setup.Timer,
    size: "large"
  }, null, 8, ["icon"]), _createElementVNode("p", null, [_cache[5] || (_cache[5] = _createTextVNode(" 考试时间", -1)), _createElementVNode("span", null, _toDisplayString($setup.timeText), 1)]), _cache[7] || (_cache[7] = _createElementVNode("p", {
    style: {
      "font-size": "14px"
    }
  }, "如果需要更换设备，请关闭网页重新进入考试", -1)), _withDirectives(_createVNode(_component_el_button, {
    style: {
      "margin-left": "10px"
    },
    color: "#1d5595",
    type: "success",
    size: "large",
    onClick: _cache[0] || (_cache[0] = $event => $setup.finishExamInStep2())
  }, {
    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("交 卷", -1)]))]),
    _: 1
  }, 512), [[_vShow, $setup.step == 2 && $props.examInfo.examType == 17]])])) : _createCommentVNode("", true), $setup.paperInfo.items && ($setup.step == 1 || $setup.step == 2) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "question-text-itemInstruction",
    innerHTML: $setup.paperInfo.items[$setup.itemNo].itemInstruction
  }, null, 8, _hoisted_4), _createElementVNode("div", {
    class: "question-text-question",
    innerHTML: $setup.clearText($setup.paperInfo.items[$setup.itemNo].questionGroupList[$setup.taskNo].questionList[0].questionStem)
  }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("p", null, "loading..", 512), [[_vShow, $setup.questStatus == 0]]), _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [[_vShow, $setup.questStatus == 1]]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass($setup.prepareTime <= 3 ? 'icon-loading icon-loading-ani' : 'icon-loading')
  }, _toDisplayString($setup.prepareTime), 3), [[_vShow, $setup.questStatus == 2 && $setup.totPrepareTime !== 0]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_progress, {
    type: "circle",
    width: "66",
    "stroke-width": "4",
    color: "#4bbbff",
    onClick: $setup.stopRecord,
    percentage: parseInt(($setup.recordTime - $setup.recordingTime) / $setup.recordTime * 100)
  }, {
    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("div", {
      class: "icon microphone-working-icon",
      style: {
        "width": "60px",
        "height": "60px",
        "background-position": "center 1px"
      }
    }, null, -1)]))]),
    _: 1
  }, 8, ["onClick", "percentage"]), _createElementVNode("p", _hoisted_8, "录音中:" + _toDisplayString($setup.recordingTime) + "s", 1)], 512), [[_vShow, $setup.questStatus == 3]]), _withDirectives(_createVNode(_component_el_button, {
    type: "primary",
    onClick: $setup.nextQuestion
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.step == 2 && $setup.itemNo == $setup.paperInfo.items.length - 1 ? "交卷" : "NEXT"), 1)]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $setup.questStatus == 4]])]), _withDirectives(_createElementVNode("div", {
    class: "down",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.scrollMove && $setup.scrollMove(...args))
  }, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "font-size": "20px",
      "color": "#fff"
    },
    icon: $setup.ArrowDown,
    size: "large"
  }, null, 8, ["icon"])], 512), [[_vShow, $setup.downBottom]])])) : _createCommentVNode("", true), $setup.paperInfo.items && ($setup.step == 0 || $setup.step == 3) ? (_openBlock(), _createBlock(_component_SelfEvaluation, {
    key: 2,
    examInfo: $props.examInfo,
    paperInfo: $setup.paperInfo,
    step: $setup.step,
    onSelfOver: $setup.changeStep
  }, null, 8, ["examInfo", "paperInfo", "step", "onSelfOver"])) : _createCommentVNode("", true), $setup.paperInfo.items && ($setup.step == 1 || $setup.step == 2) ? (_openBlock(), _createElementBlock("audio", {
    key: 3,
    id: "audio",
    onEnded: _cache[2] || (_cache[2] = $event => $setup.audioEnded(false)),
    onCanplay: _cache[3] || (_cache[3] = (...args) => $setup.audioCanPlay && $setup.audioCanPlay(...args)),
    controls: "",
    style: {
      "display": "none"
    },
    preload: "none"
  }, [_createElementVNode("source", {
    src: $setup.paperInfo.items[$setup.itemNo].itemInstructionAudio && $setup.paperInfo.items[$setup.itemNo].itemInstructionAudio.indexOf('http') == -1 ? $setup.audioUrl + $setup.paperInfo.items[$setup.itemNo].itemInstructionAudio : $setup.paperInfo.items[$setup.itemNo].itemInstructionAudio,
    type: "audio/mpeg"
  }, null, 8, _hoisted_9)], 32)) : _createCommentVNode("", true), $setup.paperInfo.items && ($setup.step == 1 || $setup.step == 2) ? (_openBlock(), _createElementBlock("audio", {
    key: 4,
    id: "question_audio",
    onEnded: _cache[4] || (_cache[4] = $event => $setup.audioEnded(true)),
    controls: "",
    style: {
      "display": "none"
    },
    preload: "none"
  }, [_createElementVNode("source", {
    src: $setup.paperInfo.items[$setup.itemNo] && $setup.paperInfo.items[$setup.itemNo].questionGroupList[$setup.taskNo].audioList[0] ? $setup.paperInfo.items[$setup.itemNo].questionGroupList[$setup.taskNo].audioList[0].mediaName : '',
    type: "audio/mpeg"
  }, null, 8, _hoisted_10)], 32)) : _createCommentVNode("", true), $setup.paperInfo.items && ($setup.step == 1 || $setup.step == 2) ? (_openBlock(), _createBlock(_component_Recorder, {
    key: 5,
    record_switch: $setup.record_switch,
    stop_switch: $setup.stop_switch,
    record_time: ($setup.recordTime - 0 + 5) * 1000,
    onSetScores: $setup.setScores,
    refText: $setup.paperInfo.items[$setup.itemNo].questionGroupList[$setup.taskNo].questionList[0].questionKey || 'test',
    onRecording: $setup.recording,
    coreType: $setup.coreType,
    qType: $setup.qType,
    onRecorderDefeat: _ctx.recorderDefeat
  }, null, 8, ["record_switch", "stop_switch", "record_time", "onSetScores", "refText", "onRecording", "coreType", "qType", "onRecorderDefeat"])) : _createCommentVNode("", true)], 64);
}